import { ChangeDetectorRef, Component, OnInit, Input, ChangeDetectionStrategy, Inject, ViewChildren, QueryList, ElementRef, SimpleChanges } from '@angular/core';
import { Row } from '../row/row.component';
import {trigger, transition, style, animate, query, stagger} from '@angular/animations';
import { DEVICE_INFO, DeviceInfo } from 'angular-engine/modules/ng-express-engine/tokens';
import { Subscription } from 'rxjs/Subscription';
import { MobileNavigationService } from 'angular-engine/engine/service/ui/mobile-navigation/mobile-navigation.service';
@Component({
  selector: 'rows',
  templateUrl: './rows.template.html',
  styleUrls: ['./rows.style.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('fadeAnimation', [
        transition('* => *', [ // each time the binding value changes
          query('.row-animatable', style({ opacity: 0 })),
          query('.row-animatable', stagger('200ms', [
              animate('300ms 0.5s ease-out', style({ opacity: 1 }))
            ])), 
        ])
    ])
  ]
})
export class Rows implements OnInit {
  public isPhone: boolean = false;
  private changes: boolean = false;
  private orientationChange: Subscription;

  @Input() initialIndex:number = 0;
  @Input() rows$: any;
  @ViewChildren('content') contentChildren:QueryList<ElementRef>

  constructor(@Inject(DEVICE_INFO) device: DeviceInfo,
  private mobileNavigationService: MobileNavigationService,
  private ref: ChangeDetectorRef
  ) { 
    this.isPhone = device.isPhone;
  }

  ngOnInit() {
    this.orientationChange = this.mobileNavigationService.orientationSubject.subscribe(()=>{
      setTimeout(() => {
        this.ref.detectChanges();
      }, 100);
    });
  }

  ngAfterViewChecked() {
    if(this.changes)
    {
      if(this.contentChildren && this.contentChildren.length)
      {
        this.contentChildren.toArray().forEach((child, index) => {
          this.mobileNavigationService.registerClientObject(index+this.initialIndex, child);
        })
      }

      this.changes = false;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.changes = true;
  }

  ngOnDestroy(): void {
    if(this.orientationChange)
    {
      this.orientationChange.unsubscribe();
    }
  }

  public position(index:number):string{
    const position = index * this.mobileNavigationService.windowWidth;
    return 'translateX(' + position + 'px)';
  }
  
}


// WEBPACK FOOTER //
// ./src/angular-framework-client-components/components/rows/rows.component.ts